import React from "react";
import classNames from "classnames";
import { Dropdown } from "semantic-ui-react";
import memoize from "memoize-weak";

const normalizeOptions = memoize((options, includeBlank, placeholder) => {
  if (options && options.length > 0 && typeof options[0] !== "object") {
    options = options.map((v) => [v, v]);
  }

  if (options && options.length > 0 && typeof options[0] === "object" && Array.isArray(options[0])) {
    options = options.map(([value, text]) => ({
      key: value,
      value,
      text,
    }));
  }

  if (options && includeBlank) {
    options = [
      {
        key: "placeholder",
        value: null,
        text: placeholder,
      },
    ].concat(options);
  }

  return options;
});

export default function SelectControl({
  name,
  onChange,
  value,
  placeholder = I18n.t("helpers.select.prompt"),
  includeBlank = false,
  children,
  options = [],
  readOnly,
  disabled,
  className,
  ...rest
}) {
  const props = {
    name,
    value: value === null ? "" : value,
    onChange: onChange && ((event, data) => onChange(data.value)),
    placeholder,
    disabled: readOnly || disabled,
    className: classNames(className, { readOnly }),
    noResultsMessage: I18n.t("helpers.select.no_results_message"),
    options: normalizeOptions(options, includeBlank, placeholder),
    ...rest,
  };

  return <Dropdown selection options={options} children={children} {...props} selectOnBlur={false} />;
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/Select.jsx